import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "polling", payment_status: null });
  const tries = useRef(0);
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      if (cancelled || tries.current >= 8) return;
      tries.current++;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState(data);
          refresh();
          return;
        }
        if (data.status === "expired") { setState(data); return; }
        setState(data);
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2500);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, refresh]);

  const paid = state.payment_status === "paid";
  const expired = state.status === "expired";

  return (
    <div className="qv-login-wrap">
      <div className="qv-login-card" style={{ textAlign: "center" }} data-testid="payment-success">
        {paid ? <CheckCircle2 size={56} color="#25D366" style={{ margin: "0 auto 18px" }} /> :
         expired ? <XCircle size={56} color="var(--qv-red)" style={{ margin: "0 auto 18px" }} /> :
         <Loader2 size={56} color="#a3a3a3" style={{ margin: "0 auto 18px", animation: "spin 1.4s linear infinite" }} />}
        <h1 className="qv-display" style={{ fontSize: "2.2rem" }}>
          {paid ? "¡PAGO CONFIRMADO!" : expired ? "PAGO CADUCADO" : "VERIFICANDO PAGO..."}
        </h1>
        <p style={{ color: "#a3a3a3", marginTop: 12 }}>
          {paid ? "Tu suscripción está activa. Disfruta de tu plan." :
           expired ? "La sesión de pago caducó. Vuelve a intentarlo." :
           "Estamos confirmando tu pago. No cierres esta página."}
        </p>
        <Link to="/app/dashboard" className="qv-btn-primary" style={{ marginTop: 22 }}>
          {paid ? "IR AL DASHBOARD" : "VOLVER"}
        </Link>
      </div>
    </div>
  );
}

export function PaymentCancelled() {
  return (
    <div className="qv-login-wrap">
      <div className="qv-login-card" style={{ textAlign: "center" }} data-testid="payment-cancelled">
        <XCircle size={56} color="var(--qv-red)" style={{ margin: "0 auto 18px" }} />
        <h1 className="qv-display" style={{ fontSize: "2.2rem" }}>PAGO CANCELADO</h1>
        <p style={{ color: "#a3a3a3", marginTop: 12 }}>No se ha realizado ningún cargo. Vuelve cuando quieras.</p>
        <Link to="/app/ajustes" className="qv-btn-primary" style={{ marginTop: 22 }}>VOLVER A AJUSTES</Link>
      </div>
    </div>
  );
}
